// 用户管理
export default [
  {
    path: "/user",
    meta: { title: "用户管理" },
    component: () => import("../views/user/index"),
    children: [
      {
        path: "/user/userList",
        name: "userList",
        meta: { title: "用户列表", isMenu: true },
        component: () => import("../views/user/userList"),
      },
      {
        path: "/user/incomeDetails",
        name: "incomeDetails",
        meta: { title: "结算明细", isMenu: true },
        component: () => import("../views/user/incomeDetails"),
      },
      {
        path: "/user/detail/subordinateDet",
        name: "subordinateDet",
        meta: { title: "下级用户" },
        component: () => import("../views/user/detail/subordinateDet.vue"),
      },
    ],
  },
]
